import React, { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaRegClock,
  FaServicestack,
  FaPhoneAlt,
} from "react-icons/fa";
import ConfirmModal from "./ConfirmModal";
import { useEngagementStore } from "./store";
import { Tooltip } from "antd";

const CustomerDetailsCard = () => {
  const [showModal, setShowModal] = useState(false);
  const { callDetails } = useEngagementStore();

  const handleCardClick = () => {
    setShowModal(true);
  };

  const handleConfirm = () => {
    setShowModal(false);
    window.open(`/lead-details/${callDetails.caseId}`, "_blank");
  };

  const handleClose = () => {
    setShowModal(false);
  };

  if (!callDetails) {
    return <div>Loading...</div>;
  }

  const truncateEmail = (email) => {
    if (email.length > 12) {
      return `${email.substring(0, 12)}...`;
    }
    return email;
  };

  return (
    <>
      <Card className="my-3 shadow-sm" style={{ width: "100%", borderRadius: "10px" }} >
        <Card.Body>
          <Card.Title className="text-center">
            Customer & Call Details
          </Card.Title>
          <div className="mb-3">
            <Row className="mb-2">
              <Col xs={4} className="d-flex flex-column gap-2">
                <div className="fw-bold">
                  <FaUser /> <span>Name:</span>
                </div>

                <Tooltip title="Click for customer details">
                  <div style={{ color: "blue", cursor: "pointer" }} onClick={handleCardClick}>
                    {callDetails.customerName}
                  </div>
                </Tooltip>
              </Col>
              <Col xs={4} className="d-flex flex-column gap-2">
                <div className="fw-bold">
                  <FaEnvelope /> Email:
                </div>
                <Tooltip title={callDetails.customerEmail}>
                  <div>
                    {truncateEmail(callDetails.customerEmail)}
                  </div>
                </Tooltip>
              </Col>
              <Col xs={4} className="d-flex flex-column gap-2">
                <div className="fw-bold">
                  <FaPhone /> Phone Number:
                </div>
                <div>{callDetails.customerPhoneNumber}</div>
              </Col>
            </Row>
            <Row>
              <Col xs={4} className="d-flex flex-column gap-2">
                <div className="fw-bold">
                  <FaServicestack /> Call:
                </div>
                <div>{callDetails.callService}</div>
              </Col>
              <Col xs={4} className="d-flex flex-column gap-2">
                <div className="fw-bold">
                  <FaPhoneAlt /> #Call:
                </div>
                <div>{callDetails.callType}</div>
              </Col>
              <Col xs={4} className="d-flex flex-column gap-2">
                <div className="fw-bold">
                  <FaRegClock /> Actual Duration:
                </div>
                <div>{callDetails.callDuration}</div>
              </Col>
            </Row>
          </div>
        </Card.Body>
      </Card>

      <ConfirmModal
        show={showModal}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
        title="Confirm Navigation"
        body="Are you sure you want to navigate to the customer details page?"
      />
    </>
  );
};

export default CustomerDetailsCard;
